'use strict'

module.exports = {
    videoPosterPrefix: 'addPanelData/sections/videos_en/3DGalleries/gallery-video-thumb-3d-',
    videoSrcPrefix: 'gallery-video-thumb-3d-'
}